/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Studio_Export_Segment_Too_ShortInputs */

const en_ui_studio_export_segment_too_short = /** @type {(inputs: Ui_Studio_Export_Segment_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segment too short to export`)
};

const de_ui_studio_export_segment_too_short = /** @type {(inputs: Ui_Studio_Export_Segment_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abschnitt ist zu kurz für den Export`)
};

/**
* | output |
* | --- |
* | "Segment too short to export" |
*
* @param {Ui_Studio_Export_Segment_Too_ShortInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_export_segment_too_short = /** @type {((inputs?: Ui_Studio_Export_Segment_Too_ShortInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Export_Segment_Too_ShortInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_export_segment_too_short(inputs)
	return de_ui_studio_export_segment_too_short(inputs)
});